<template>
  <div class="contractManageList">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-select v-model="parkId" class="select" @change="getGateCamera">
            <el-option key :label="$t('lang.lab_pleParkName')" value=''></el-option>
            <el-option v-for="(item,index) in parks" :key="index" :label="item.parkName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="gateCameraNum" class="select">
            <el-option key :label="$t('lang.lab_cameraName')" value=''></el-option>
            <el-option v-for="(item,index) in gateCameras" :key="index" :label="item.cameraName" :value="item.cameraNum"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input v-model="carNum" :placeholder="$t('lang.lab_pleCarNum')"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input :placeholder="$t('lang.lab_preHouseholdNameOrPhone')" v-model="preHouseholdNameOrPhone"></el-input>  
        </el-form-item>
         <el-form-item>
          <el-input :placeholder="$t('lang.lab_parkingNumber')" v-model="parkingNumber"></el-input>  
        </el-form-item>
        <el-form-item class="key-data">
          <el-date-picker v-model="createTimeSt" type="datetime" :placeholder="$t('lang.lab_otDoorDeviceSon')+' >'" align="right"
            value-format="timestamp" :picker-options="pickerOptions1">
          </el-date-picker>
        </el-form-item>
        <el-form-item class="key-data">
          <el-date-picker v-model="createTimeEn" type="datetime" :placeholder="$t('lang.lab_otDoorDeviceSon')+' <'" align="right"
            value-format="timestamp" :picker-options="pickerOptions1">
          </el-date-picker>
        </el-form-item> 
        <el-form-item>
            <el-select v-model="errorCode" :placeholder="$t('lang.resourStatus')">
              <el-option :label="$t('lang.resourWriteStatus')" value></el-option>
              <el-option :label="$t('lang.lab_errorCode0')" value = 0></el-option>
              <el-option :label="$t('lang.lab_errorCode2')" value = 2></el-option>
              <el-option :label="$t('lang.lab_errorCode3')" value = 3></el-option>
              <el-option :label="$t('lang.lab_errorCode4')" value = 4></el-option>
              <el-option :label="$t('lang.lab_errorCode5')" value = 5></el-option>
              <el-option :label="$t('lang.lab_errorCode6')" value = 6></el-option>
              <el-option :label="$t('lang.lab_errorCode7')" value = 7></el-option>
              <el-option :label="$t('lang.lab_errorCode8')" value = 8></el-option>
              <el-option :label="$t('lang.lab_errorCode9')" value = 9></el-option>
              <el-option :label="$t('lang.lab_errorCode10')" value = 10></el-option>
              <el-option :label="$t('lang.lab_errorCode11')" value = 11></el-option>
              <el-option :label="$t('lang.lab_errorCode12')" value = 12></el-option>
              <el-option :label="$t('lang.lab_errorCode13')" value = 13></el-option>
              <el-option :label="$t('lang.lab_errorCode14')" value = 14></el-option>
              <el-option :label="$t('lang.lab_errorCode15')" value = 15></el-option>
              <el-option :label="$t('lang.lab_errorCode16')" value = 16></el-option>
              <el-option :label="$t('lang.lab_errorCode17')" value = 17></el-option>
              <el-option :label="$t('lang.lab_errorCode18')" value = 18></el-option>
            </el-select>
          </el-form-item>       
        <el-button type="primary" @click="topics1">{{$t('lang.btn_search')}}</el-button>
      </el-form>
    </div>
    <el-card>
      <el-table :data="tableData" class="wid100"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
        <!-- checkbox -->
        <el-table-column type="selection" width="55" v-if="teleInfosListcheckbox"></el-table-column>
        <!-- 序号 -->
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <!-- 车场名称 -->
        <el-table-column prop="parkId" :label="$t('lang.lab_parkName')">
          <template slot-scope="scope" v-if="scope&&scope.row.carPark">{{scope.row.carPark.parkName}}</template>
        </el-table-column>
        <!-- 摄像头编号  -->
        <el-table-column prop="cameraNum" :label="$t('lang.lab_cameraNum')">
          <template slot-scope="scope" v-if="scope&&scope.row.cameraNum">{{scope.row.cameraNum}}</template>
        </el-table-column>
        <!-- 车牌号 -->
        <el-table-column prop="carNum" :label="$t('lang.lab_carNumber')"></el-table-column>
        <!-- 出入口类型 -->
        <el-table-column prop="gateType" :label="$t('lang.lab_gateType')">
          <template slot-scope="scope">
            <span v-if="scope.row.gateType === 1">{{$t('lang.lab_gateEntry')}}</span>
            <span v-if="scope.row.gateType === 2">{{$t('lang.lab_gateExit')}}</span>
          </template>
        </el-table-column> 
        <el-table-column prop="gateName" :label="$t('lang.lab_gateName')">
          <template slot-scope="scope" v-if="scope&&scope.row.carGate">{{scope.row.carGate.gateName}}</template>
        </el-table-column>
        <!-- 操作时间 -->
        <el-table-column prop="createTime" :label="$t('lang.lab_otDoorDeviceSon')">
          <template slot-scope="scope">{{scope.row.createTime | time}}</template>
        </el-table-column>
         <!-- <el-table-column prop="identifyTime" label="识别时长/秒">
          <template slot-scope="scope">{{scope.row.identifyTime}}</template>
        </el-table-column> -->
        <el-table-column prop="errorCode" :label="$t('lang.resourStatus')">
          <template slot-scope="scope">
            <span v-if="scope.row.errorCode === 0">{{$t('lang.lab_errorCode0')}}</span>
            <span v-if="scope.row.errorCode === 2">{{$t('lang.lab_errorCode2')}}</span>
            <span v-if="scope.row.errorCode === 3">{{$t('lang.lab_errorCode3')}}</span>
            <span v-if="scope.row.errorCode === 4">{{$t('lang.lab_errorCode4')}}</span>
            <span v-if="scope.row.errorCode === 5">{{$t('lang.lab_errorCode5')}}</span>
            <span v-if="scope.row.errorCode === 6">{{$t('lang.lab_errorCode6')}}</span>
            <span v-if="scope.row.errorCode === 7">{{$t('lang.lab_errorCode7')}}</span>
            <span v-if="scope.row.errorCode === 8">{{$t('lang.lab_errorCode8')}}</span>
            <span v-if="scope.row.errorCode === 9">{{$t('lang.lab_errorCode9')}}</span>
            <span v-if="scope.row.errorCode === 10">{{$t('lang.lab_errorCode10')}}</span>
            <span v-if="scope.row.errorCode === 11">{{$t('lang.lab_errorCode11')}}</span>
            <span v-if="scope.row.errorCode === 12">{{$t('lang.lab_errorCode12')}}</span>
            <span v-if="scope.row.errorCode === 13">{{$t('lang.lab_errorCode13')}}</span>
            <span v-if="scope.row.errorCode === 14">{{$t('lang.lab_errorCode14')}}</span>
            <span v-if="scope.row.errorCode === 15">{{$t('lang.lab_errorCode15')}}</span>
            <span v-if="scope.row.errorCode === 16">{{$t('lang.lab_errorCode16')}}</span>
            <span v-if="scope.row.errorCode === 17">{{$t('lang.lab_errorCode17')}}</span>
            <span v-if="scope.row.errorCode === 18">{{$t('lang.lab_errorCode18')}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="imagePath" :label="$t('lang.lab_picture')">
          <template slot-scope="scope" v-if="scope.row.imagePath!== null">
            <viewer :images="scope.row.imagePath.split(',')" class="img-width">
              <img :src="scope.row.imagePath" class="img">
            </viewer>
          </template>
        </el-table-column>        
        <!-- 操作 
        <el-table-column prop="operate" :label="$t('lang.lab_operation')" fixed="right"
          :width="require('@/config/enum').opr_width1">
          <template slot-scope="scope">
            <el-button @click="changeTel(scope.row.id)">{{$t('lang.btn_detail')}}</el-button>
          </template>
        </el-table-column>-->
        
      </el-table>
      <!-- 添加页码 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
    <!-- 添加弹框 -->
    <el-dialog :title="titleShow" :visible.sync="diaIsShow" :close-on-click-modal="false" center top="130px"
      width="800px" @closed="handleDialogClosed">
      <!-- 表单验证 -->
      <el-form ref="form" :model="form" :rules="rules" class="wid100" :label-width="require('@/config/enum').c_ws4" :label-suffix="require('@/config/enum').c_colon">
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('lang.lab_carNumber')">
              <span>{{ this.form.carNum }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('lang.resourStatus')">
              <span v-if="form.state === 1">{{$t('lang.lab_In')}}</span>
              <span v-if="form.state === 2">{{$t('lang.lab_Out')}}</span>
            </el-form-item>
          </el-col>
        </el-row> 
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('lang.lab_InTime')">
              <span>{{ this.form.inTime | time}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('lang.lab_OutTime')">
              <span>{{ this.form.outTime | time }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('lang.lab_inOutDeff')">
              <span>{{ this.form.inOutDeff | formatInOutDeff}}</span>
            </el-form-item>
          </el-col>
        </el-row>       
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  /**
   *@ClassName:teleInfo
   *@Description:电话信息
   *@author:李斌
   *@Copyright:格众科技
   *@date:2020-03-13
   */
  import { mapGetters } from 'vuex'

  export default {
    name: '/manage/main.carInOutList',
    filters: {
      formatInOutDeff(value) {
        var theTime = parseInt(value) // 需要转换的时间秒 
        var theTime1 = 0 // 分 
        var theTime2 = 0 // 小时 
        var theTime3 = 0 // 天
        if (theTime > 60) {
          theTime1 = parseInt(theTime / 60)
          theTime = parseInt(theTime % 60)
          if (theTime1 > 60) {
            theTime2 = parseInt(theTime1 / 60)
            theTime1 = parseInt(theTime1 % 60)
            if (theTime2 > 24) {
              // 大于24小时
              theTime3 = parseInt(theTime2 / 24)
              theTime2 = parseInt(theTime2 % 24)
            }
          }
        }
        var result = ''
        if (theTime > 0) {
          result = '' + parseInt(theTime) + '秒'
        }
        if (theTime1 > 0) {
          result = '' + parseInt(theTime1) + '分' + result
        }
        if (theTime2 > 0) {
          result = '' + parseInt(theTime2) + '小时' + result
        }
        if (theTime3 > 0) {
          result = '' + parseInt(theTime3) + '天' + result
        }
        return result
      }
    },
    data() {
      return {
        isDisabled: true, // 按钮置灰
        saveData: '', // 存储json字符串
        name: '', // 名称
        content: '', // 电话
        serviceTime: '', // 服务时间
        editId: '', // 接收参数
        errorCode: '',
        titleShow: '', // 弹框标题
        diaIsShow: false, // 弹框是否显示
        pageNum: 1, // 页数
        pageSize: 20, // 每页数量
        pageCount: 0, // 总页数
        tableData: [], // 表单数据
        multipleSelection: [], // 多选框
        type: '', // 判断checkbox的值
        teleInfosListcheckbox: require('@/config/enum').teleInfosListcheckbox, // 是否隐藏复选框
        form: {
          
        },
        rules: {
          parkName: [{
            required: true,
            message: this.$i18n.t('lang.lab_pleParkName'),
            trigger: 'blur'
          }],
          totalNum: [{
            required: true,
            message: this.$i18n.t('lang.lab_pleCarTtotalNum'),
            trigger: 'blur'
          }]
        },
        parks: [], // 车场集合
        gateCameras: [], // 车场摄像头集合
        parkId: '',
        gateCameraNum: '',
        carNum: '',
        preHouseholdNameOrPhone: '',
        parkingNumber: '',
        createTimeSt: '',
        createTimeEn: '',
        pickerOptions1: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date())
            }
          }, {
            text: '昨天',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', date)
            }
          }, {
            text: '一周前',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', date)
            }
          }]
        },
      }
    },
    // 初始化
    created() {
      this.getParks(this.gardenId)
      this.topics()
    },
    computed: {
      ...mapGetters(['gardenId'])
    },
    // 监听小区编号
    watch: {
      gardenId: function (newFlag, oldFlag) {
        this.topics()
      },
      form: {
        handler(newVal, oldVal) {
          let tempRule = JSON.stringify(newVal)
          if (tempRule === this.saveData) {
            this.isDisabled = true
          } else {
            this.isDisabled = false
          }
        },
        deep: true,
        immediate: true
      }
    },
    methods: {
      // 用户名只能输入数字
      keyBA() {
        // 仅保留数字和"."
        this.form.totalNum = this.form.totalNum.replace(/[^\d]/g, '')
        // 首位是0的话去掉
        if (this.form.totalNum.indexOf('.') < 0 && this.form.totalNum != '') {
          this.form.totalNum = parseFloat(this.form.totalNum)
        }
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      // 列表斑马线
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // 多选框
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      topics() {
        let loading = this.$loading()
        if (this.createTimeSt == null) {
          this.createTimeSt = ''
        }
        if (this.createTimeEn == null) {
          this.createTimeEn = ''
        }        
        this.$get(
          `/carRecord?gardenId=${this.gardenId}&parkId=${this.parkId}&cameraNum=${this.gateCameraNum}&carNum=${this.carNum}&preHouseholdNameOrPhone=${this.preHouseholdNameOrPhone}&parkingNumber=${this.parkingNumber}&createTimeSt=${this.createTimeSt}&createTimeEn=${this.createTimeEn}&pageNo=${this.pageNum}&pageSize=${this.pageSize}&errorCode=${this.errorCode}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      topics1() {
        this.pageNum = 1
        let loading = this.$loading()
        if (this.createTimeSt == null) {
          this.createTimeSt = ''
        }
        if (this.createTimeEn == null) {
          this.createTimeEn = ''
        }
        this.$get(
          `/carRecord?gardenId=${this.gardenId}&parkId=${this.parkId}&cameraNum=${this.gateCameraNum}&carNum=${this.carNum}&preHouseholdNameOrPhone=${this.preHouseholdNameOrPhone}&parkingNumber=${this.parkingNumber}&createTimeSt=${this.createTimeSt}&createTimeEn=${this.createTimeEn}&pageNo=1&pageSize=${this.pageSize}&errorCode=${this.errorCode}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取车场List
      getParks(val) {
        this.$get(`carPark?pageNo=1&pageSize=999&gardenId=` + val).then(
          res => {
            if (res && res.errCode === 0) {
              this.parks = res.list
              if (res.list.length > 0) {
								this.parkId = res.list[0].id
                this.getGateCamera()
							}
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      getGateCamera() {
        this.gateCameras = []
        this.gateCameraNum = ''
        if (this.parkId > 0) {
          this.$get(`carGateCamera?pageNo=1&pageSize=999&parkId=` + this.parkId).then(
            res => {
              if (res && res.errCode === 0) {
                this.gateCameras = res.list
              }
            },
            error => {
              this.$message.error(error)
            }
          )
        }
      },
      // 添加电话
      addTel() {
        this.editId = ''
        this.titleShow = this.$i18n.t('lang.lab_addPark')
        this.form.parkName = ''
        this.form.totalNum = ''
        this.form.isRepeat = '1'
        this.diaIsShow = true
      },
      // 修改电话信息
      changeTel(id) {
        this.getData(id)
        this.titleShow = this.$i18n.t('lang.btn_detail')
        this.diaIsShow = true
      },
       // id查询详情
    getData(id) {
      let loading = this.$loading()
      this.$get(`/carInOut/` + id).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            console.log(res)
            this.form = res.carInOut
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
      addPlace(id) {
        this.$router.push({
          path: '/manage/carPlaceList',
          query: {
            id: id
          }
        })
      },
      addGate(id) {
        this.$router.push({
          path: '/manage/carGateList',
          query: {
            id: id
          }
        })
      },
      // 删除
      delTele(id) {
        let loading = this.$loading()
        this.$confirm(
            this.$i18n.t('lang.lab_isdelete'),
            this.$i18n.t('lang.lab_prompt'), {
              confirmButtonText: this.$i18n.t('lang.btn_confirm'),
              cancelButtonText: this.$i18n.t('lang.btn_cancel'),
              type: 'warning'
            }
          ).then(() => {
            this.$delete(`carPark/` + id).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_del_success')
                  })
                  this.topics()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
      },
      // 保存
      save(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            if (this.editId === '') {
              let params = {
                gardenId: this.gardenId,
                parkName: this.form.parkName,
                totalNum: this.form.totalNum,
                isRepeat: this.form.isRepeat
              }
              if (this.gardenId === 0) {
                this.$message.error(this.$i18n.t('lang.reportPleaseSelectVillage'))
                return
              }
              let loading = this.$loading()
              this.$post(`/carPark/`, params).then(
                res => {
                  loading.close()
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.diaIsShow = false
                    this.topics()
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            } else {
              let loading = this.$loading()
              let params = {
                parkName: this.form.parkName,
                totalNum: this.form.totalNum,
                isRepeat: this.form.isRepeat
              }
              this.$patch(`/carPark/${this.editId}`, params).then(
                res => {
                  loading.close()
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.diaIsShow = false
                    this.topics()
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
              console.log(params.type)
            }
          }
        })
      },
      clear() {
        this.$refs.form.resetFields()
        this.form.parkName = ''
        this.form.totalNum = ''
        this.form.isRepeat = '1'
      },
      // 监听关闭dialog
      handleDialogClosed() {
        this.clear()
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNum = val
        this.topics()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNum = 1
        this.pageSize = val
        this.topics()
      }
    }
  }
</script>

<style lang="scss">
  .img {
      width: 60px;
      height: 40px;
      border: 1px solid lightgray;
      border-radius: 5px;
      padding: 5px;
    }
    .img-width {
      overflow: hidden !important;
      text-overflow: ellipsis !important;
      white-space: nowrap !important;
      max-width: 320px;
    }
  .contractManageList {
    .detp-type {
      .el-form-item__content {
        width: 100%;

        .el-select {
          width: 315px;

          .el-input__inner {
            min-width: 100px;
          }
        }
      }
    }

    .el-collapse-item__header {
      font-size: 16px;
      padding-left: 0%;
      margin-left: 0px;
      border-bottom: 0px;
    }

    .el-collapse {
      border-top: 0px;
    }

    .el-collapse-item__wrap {
      will-change: height;
      background-color: #FFF;
      overflow: hidden;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      border-bottom: 0px solid #EBEEF5;
    }

    .key-input {
      width: 30%;

      .el-form-item__content {
        width: 100%;

        .el-input__inner {
          min-width: 100px;
        }
      }
    }

    .key-data {
      .el-date-editor {

        &.el-input,
        .el-input__inner {
          width: 200px;
        }

        .el-range-separator {
          height: 28px;
          line-height: 28px;
        }
      }
    }

    .selee {
      width: 28%;

      .el-form-item__content {
        width: 100%;
        min-width: 180px;

        .el-select {
          width: 100%;
          min-width: 180px;

          .el-input--suffix {
            min-width: 180px;
          }
        }
      }
    }

    .key-dept {
      width: 50%;

      .el-form-item__content {
        width: 100%;

        .el-select {
          width: 100%;
        }
      }

    }

    .red {
      color: red;
    }
  }
</style>